/**
 * Filename from a Content-Disposition header (RFC 5987 `filename*` first, then `filename`).
 * @param {string|null} contentDisposition
 * @param {string} fallback
 * @returns {string}
 */
export function attachmentFilename(contentDisposition, fallback) {
	if (!contentDisposition) return fallback;
	const utf8Match = contentDisposition.match(/filename\*=UTF-8''(.+?)(?:;|$)/);
	if (utf8Match) {
		try {
			return decodeURIComponent(utf8Match[1]);
		} catch {
			// Malformed URI — fall through to the plain filename.
		}
	}
	const plainMatch = contentDisposition.match(/filename="?(.+?)"?(?:;|$)/);
	return plainMatch ? plainMatch[1] : fallback;
}
